import { type ReactElement, useMemo } from 'react';
import './authn-layout.less';

import { NotificationSystem } from '@imprivata-cloud/design-system';
import type { NotificationBannerProps } from 'src/components/notificationBanner/NotificationBanner';

import ImprivataLogo from '../../assets/Imprivata_Logo.svg?react';
import { AuthenticationHeader } from './components/authentication-header/authentication-header';
import { EnrollmentHeader } from './components/enrollment-header/enrollment-header';

export enum LayoutHeaders {
  AUTHENTICATION = 'AUTHENTICATION',
  ENROLL_CONSENT = 'ENROLL_CONSENT',
}

interface AuthnLayoutProps {
  children: React.ReactNode;
  logoUrl?: string | React.ReactNode;
  hexImage?: React.ReactNode;
  header: LayoutHeaders;
  banner?: NotificationBannerProps;
  renderCustomBanner?: ReactElement;
  hideLayout?: boolean;
}

export const AuthnLayout = ({
  children,
  logoUrl,
  hexImage,
  header,
  banner,
  renderCustomBanner,
  hideLayout,
}: AuthnLayoutProps) => {
  const loadLogo = useMemo(
    () =>
      typeof logoUrl === 'string' ? (
        <img src={logoUrl} alt="logo" className="card-header-logo" />
      ) : (
        logoUrl
      ),
    [logoUrl],
  );

  const renderHeader = useMemo(() => {
    switch (header) {
      case LayoutHeaders.AUTHENTICATION:
        return (
          <AuthenticationHeader
            banner={!renderCustomBanner ? banner : undefined}
            logoUrl={loadLogo}
            hexImage={hexImage}
          />
        );
      case LayoutHeaders.ENROLL_CONSENT:
        return (
          <EnrollmentHeader
            banner={!renderCustomBanner ? banner : undefined}
            hexImage={hexImage}
          />
        );
      default:
        return null;
    }
  }, [header, banner, loadLogo, hexImage, renderCustomBanner]);

  return (
    <div
      className={`authn-layout-root ${hideLayout && 'hide-layout'}`}
    >
      <NotificationSystem />
      {renderCustomBanner}
      {renderHeader}
      <div className="authn-layout-body">{children}</div>
      <div className="authn-layout-footer">
        <ImprivataLogo />
      </div>
    </div>
  );
};
